import { render, staticRenderFns } from "./AS_KnowYourTariff.vue?vue&type=template&id=3266232e&scoped=true&"
import script from "./AS_KnowYourTariff.vue?vue&type=script&lang=js&"
export * from "./AS_KnowYourTariff.vue?vue&type=script&lang=js&"
import style0 from "./AS_KnowYourTariff.vue?vue&type=style&index=0&id=3266232e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3266232e",
  null
  
)

export default component.exports